var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRealEstate = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEFF2",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7 25.5h18.5M20.359 10.08h-8.22c-1.7 0-3.08 1.38-3.08 3.08v12.33h14.39V13.17a3.1 3.1 0 0 0-3.09-3.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.251 21.39c-1.14 0-2.06.92-2.06 2.06v1.84c0 .12.1.22.22.22h3.68c.12 0 .22-.1.22-.22v-1.84c0-1.14-.92-2.06-2.06-2.06M19.339 13.17h-1.03v1.03h1.03zM14.2 13.17h-1.03v1.03h1.03zM19.339 17.79h-1.03v1.03h1.03zM14.2 17.79h-1.03v1.03h1.03zM19.33 7h-6.17c-1.14 0-2.06.92-2.06 2.06v1.03h10.28V9.06C21.39 7.92 20.47 7 19.33 7"
  })));
};
export default SvgRealEstate;